/**
 * @generated SignedSource<<bee5b763e1f49ec341e84ccaf67b3078>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConnectInboxAudience = "CUSTOMERS" | "EMPLOYEES";
export type ConnectAdminScreenQuery$variables = Record<PropertyKey, never>;
export type ConnectAdminScreenQuery$data = {
  readonly store: {
    readonly connectInboxes: ReadonlyArray<{
      readonly audience: ConnectInboxAudience | null;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ConnectAdminScreenInboxListItem_inbox">;
    }>;
  };
};
export type ConnectAdminScreenQuery = {
  response: ConnectAdminScreenQuery$data;
  variables: ConnectAdminScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "audience",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConnectAdminScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ConnectInbox",
            "kind": "LinkedField",
            "name": "connectInboxes",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ConnectAdminScreenInboxListItem_inbox"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ConnectAdminScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ConnectInbox",
            "kind": "LinkedField",
            "name": "connectInboxes",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customTitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoCategory",
                "kind": "LinkedField",
                "name": "todoCategory",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "icon",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isPrivate",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoCategoryTag",
                "kind": "LinkedField",
                "name": "tags",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d4459427411c4bcd049d1954bd95bec4",
    "id": null,
    "metadata": {},
    "name": "ConnectAdminScreenQuery",
    "operationKind": "query",
    "text": "query ConnectAdminScreenQuery {\n  store {\n    connectInboxes {\n      id\n      audience\n      ...ConnectAdminScreenInboxListItem_inbox\n    }\n    id\n  }\n}\n\nfragment AHTeamIcon on Team {\n  icon\n}\n\nfragment AHTeamIconCircle on Team {\n  color\n  ...AHTeamIcon\n  isPrivate\n}\n\nfragment ConnectAdminScreenInboxListItem_inbox on ConnectInbox {\n  id\n  audience\n  customTitle\n  todoCategory {\n    title\n    id\n  }\n  teams {\n    id\n    name\n    ...DialogButtonTeams_teams\n  }\n  tags {\n    ...TodoToolbarButtonTags_tags\n  }\n}\n\nfragment DialogButtonTeamsDetail_team on Team {\n  id\n  ...AHTeamIconCircle\n}\n\nfragment DialogButtonTeams_teams on Team {\n  id\n  name\n  ...DialogButtonTeamsDetail_team\n}\n\nfragment TodoTagButtonContentActive_todoCategoryTag on TodoCategoryTag {\n  id\n  title\n  color\n}\n\nfragment TodoToolbarButtonTags_tags on TodoCategoryTag {\n  ...TodoTagButtonContentActive_todoCategoryTag\n}\n"
  }
};
})();

(node as any).hash = "63afc60497bf6014cabb939eaf114c13";

export default node;
